export default __webpack_public_path__ + "assets/images/a11521ed4db3a539640a088bf7cd08d8.png";